/**
 * FILE: packages/utils/src/uuid.ts
 * PURPOSE: Shared business utility.
 * AGENT_CONTEXT: Pure functions. No React, no Supabase client imports.
 * LAST_REVIEWED: 2026-05-07
 */

/** RFC 4122 UUID (versions 1–5). Used to guard Supabase .eq('id', ...) calls. */
const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

export function isUuid(value: string | undefined | null): boolean {
  return Boolean(value && UUID_RE.test(value.trim()))
}
